var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary","depressed":"","small":"","disabled":_vm.disableAllFields},on:{"click":_vm.toggleState}},[_c('v-icon',{attrs:{"id":"three-state-button-icon"}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }